import React, { useState, useRef } from 'react'
import Accordion from '../../../components/Accordion/Accordion'
import ResponsiveContainer from '../../../layouts/ResponsiveContainer'
import { FAQs } from '../../../interfaces/FAQs'
import Button from '../../../components/Buttons/Button'

const LIMIT = 5

const FAQS = ({ faqs }: { faqs: FAQs[] }) => {
    const [showAll, setShowAll] = useState(false)
    const sectionRef = useRef<HTMLDivElement>(null)

    const visibleFaqs = showAll ? faqs : faqs?.slice(0, LIMIT)
    const hasMore = faqs?.length > LIMIT

    const handleToggle = () => {
        const wasShowingAll = showAll
        setShowAll(prev => !prev)

        if (wasShowingAll) {
            setTimeout(() => {
                sectionRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' })
            }, 0)
        }
    }

    return (
        <div className='flex flex-col items-center'>
            <ResponsiveContainer className='flex flex-col gap justify-center'>
                <h2
                    ref={sectionRef}
                    className='text-hmedium md:text-dsmall text-brand-green-20 mt-20'
                >
                    Preguntas frecuentes
                </h2>
                <div className='mt-8 flex flex-col gap-4'>
                    {visibleFaqs && visibleFaqs.map(({ pregunta, respuesta, id }, index) => (
                        <Accordion
                            title={pregunta}
                            answer={respuesta}
                            isOpen={index === 0}
                            key={id}
                        />
                    ))}
                </div>

                <div className='flex justify-end w-full'>
                    {hasMore && (
                        <Button
                            onClick={handleToggle}
                            className='mt-4 text-primary-100 bg-brand-orange-20 rounded-sm hover:opacity-80 hover:shadow-custom-dual'
                            label={`${showAll ? 'Mostrar menos' : `Mostrar más`}`}
                            disableHover={true}
                        />
                    )}
                </div>
            </ResponsiveContainer>
        </div>
    )
}

export default FAQS